import { useEffect, useState } from 'react';
import { Link, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { apiLogout, apiMe } from './api';
import type { User } from './types';
import Login from './pages/Login';
import Label from './pages/Label';
import Review from './pages/Review';
import Admin from './pages/Admin';
import Examples from './pages/Examples';
import TaskPicker from './pages/TaskPicker';
import Verify from './pages/Verify';

export default function App() {
  const [user, setUser] = useState<User | null | undefined>(undefined);
  const navigate = useNavigate();

  useEffect(() => {
    apiMe()
      .then(r => setUser(r.user))
      .catch(() => setUser(null));
  }, []);

  if (user === undefined) {
    return <div className="container">載入中…</div>;
  }

  return (
    <div className="app">
      <header className="topbar">
        <div className="brand">停止線標註</div>
        <nav>
          {user && <Link to="/label">標註</Link>}
          {user && <Link to="/examples">範例</Link>}
          {user?.is_admin && <Link to="/review">檢視</Link>}
          {user?.is_admin && <Link to="/admin">管理</Link>}
        </nav>
        <div className="userbox">
          {user ? (
            <>
              <span title={user.email}>{user.email}</span>
              <button
                onClick={async () => {
                  await apiLogout();
                  setUser(null);
                  navigate('/login');
                }}
              >
                登出
              </button>
            </>
          ) : (
            <Link to="/login">登入</Link>
          )}
        </div>
      </header>

      <main className="container">
        <Routes>
          <Route path="/" element={<Navigate to={user ? '/label' : '/login'} replace />} />
          <Route path="/login" element={<Login onLoggedIn={u => setUser(u)} />} />
          <Route path="/verify" element={<Verify onLoggedIn={u => setUser(u)} />} />
          <Route
            path="/label"
            element={user ? <TaskPicker /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/label/:taskId"
            element={user ? <Label /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/label/:taskId/:eventId"
            element={user ? <Label /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/examples"
            element={user ? <Examples /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/review"
            element={user?.is_admin ? <Review /> : <Navigate to="/" replace />}
          />
          <Route
            path="/admin"
            element={user?.is_admin ? <Admin /> : <Navigate to="/" replace />}
          />
        </Routes>
      </main>
    </div>
  );
}
